import { Grid, styled } from '@mui/material';

const StyledTextFieldContainer = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export default StyledTextFieldContainer;
